module.exports = __webpack_public_path__ + "img/new1-img4.861db818.png";